import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useEndFlowModal } from '@/contexts/endFlowModalContext';

import { createBillingInfo, editBillingInfo, editIndividualProfile, getBillingInfo } from '../functions/individual';

export const useEditIndividual = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['edit-individual-profile'],
    mutationFn: editIndividualProfile,
    onError: (e: any) => {
      showError({});
      console.error('Error updating individual profile.', e);
    }
  });
};

export const useEditIndividualName = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['edit-individual-name'],
    mutationFn: editIndividualProfile,
    onError: (e: any) => {
      showError({});
      console.error('Error updating individual name.', e);
    }
  });
};

export const useCreateBillingInfo = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['create-billing-info'],
    mutationFn: createBillingInfo,
    onError: (e: any) => {
      const axiosError = e as AxiosError;
      showError({});
      console.error('Error creating billing info.', axiosError.response?.data);
    }
  });
};

export const useEditBillingInfo = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['edit-billing-info'],
    mutationFn: editBillingInfo,
    onError: (e: any) => {
      showError({});
      console.error('Error updating billing info.', e);
    }
  });
};

export const useGetBillingInfo = () =>
  useQuery({
    queryKey: ['get-billing-info'],
    queryFn: () => getBillingInfo()
  });
